import React from 'react'
import './styles.css' // Import the CSS file for styling
import FixWidthContainer from '../../atoms/fixWidthContainer'
import Spacer from '../../atoms/Spacer'
import services1 from '../../../assets/img/services_1.png'
import services2 from '../../../assets/img/services_2.jpg'
import borboleta1 from '../../../assets/img/borboleta_1.png'
import borboleta2 from '../../../assets/img/borboleta_2.png'
import borboleta4 from '../../../assets/img/borboleta_4.png'
import ServiceCard from '../../atoms/ServiceCard'
import CommonButton from '../../atoms/CommonButton'

const Services = () => {
  const [isMobile, setIsMobile] = React.useState(false)

  React.useEffect(() => {
    if (window.innerWidth < 768) {
      setIsMobile(true)
    }
  }, [])

  return (
    <div
      style={{
        zIndex: 2,
      }}
    >
      {isMobile ? (
        <>
          <Spacer size={55} />
          <FixWidthContainer>
            <CommonButton
              backgroundColor={'transparent'}
              color="#397441"
              alignSelf={'center'}
              fontSize={16}
              height={40}
            >
              Serviços Oferecidos
            </CommonButton>
            <Spacer size={10} />
            <div className="services-container">
              <div className="service-item-with-image green-bg">
                <h3>Consulta Pediátrica Pré-Natal</h3>
                <div>
                <p>O primeiro contato entre a família e o Pediatra deve acontecer, idealmente, antes do nascimento da criança, por volta da 30ª semana de gestação. Essa consulta é essencial para:</p>
                <ul>
                  <li>Conhecer e escolher o profissional que irá acompanhar a família após o nascimento da criança</li>
                  <li>Avaliar a evolução da gestação e exames realizados até o momento, checando e intervindo em eventuais fatores de risco para saúde da criança</li>
                  <li>Checar e adequar imunizações da gestante</li>
                  <li>Tirar dúvidas e planejar cuidados com o bebê durante o parto e primeiras horas de vida</li>
                </ul>
                </div>
                <div>
                  <img
                    src={services1}
                    style={{ height: 500 }}
                    alt="services1"
                  />
                </div>
              </div>
              <div className="service-item gray-bg">
                <h3>Acompanhamento do Primeiro Mês de Vida</h3>
                <p>O primeiro mês de vida requer cuidados específicos tanto do ponto de vista clínico, quanto em relação à adaptação da casa à chegada do bebê.</p>
                <p>A primeira consulta do bebê após a alta da maternidade deve acontecer idealmente no quinto dia de vida, momento ideal para avaliar a presença de icterícia neonatal, estabelecimento do aleitamento materno e ganho de peso.</p>
                <p>Partindo das condições clínicas do bebê e necessidades familiares, estabelecemos um planejamento em relação à periodicidade de consultas no primeiro mês.</p>
                <p>Quando necessário, o acompanhamento do primeiro mês de vida pode ser realizado em domicílio.</p>
              </div>
              <div className="service-item-with-image light-green-bg">
                <img
                  src={services2}
                  style={{
                    margin: 'auto',
                    width: 280,
                    marginTop: 5,
                    marginBottom: 10,
                    borderRadius: 20,
                  }}
                  alt="services2"
                />
                <h3>Consulta Pediátrica de Urgência </h3>
                <p>A agenda em meu consultório é organizada de forma a viabilizar o atendimento de quadros agudos e urgentes com maior agilidade. Garantindo que a criança seja avaliada pelo profissional que já a conhece, e reduzindo a necessidade de visitas a pronto-atendimentos.</p>
              </div>
            </div>
            <Spacer size={20} />
            <div className="services-container">
              <div className="service-item gray-bg">
                <h3>Consulta de Puericultura (Rotina)</h3>
                <p>As consultas de Puericultura acontecem mensalmente, pelo menos até o sexto mês de vida. A partir de então os intervalos são definidos de maneira individualizada, à depender do contexto da criança e sua familia.</p>
                <p>Nestes encontros avaliamos: peso, crescimento, desenvolvimento infantil, vacinação, rotinas (alimentação, sono, atividade física, uso de telas), além, claro de todas as outras demandas trazidas pela família.</p>
              </div>
            </div>
          </FixWidthContainer>
        </>
      ) : (
        <>
          <Spacer size={80} />
          <FixWidthContainer>
          <CommonButton
              backgroundColor={'transparent'}
              color="#397441"
              alignSelf={'center'}
              fontSize={16}
              height={40}
            >
              Serviços Oferecidos
            </CommonButton>
            <Spacer size={20} />
            <img
              style={{
                position: 'absolute',
                top: 1040,
                left: -36,
                zIndex: 1,
                height: 125,
                width: 125,
                transform: 'rotate(49deg)',
              }}
              src={borboleta2}
              alt="borboleta1"
            />
            <img
              style={{
                position: 'absolute',
                top: 1630,
                right: 130,
                zIndex: 1,
                height: 30,
                width: 30,
                // transform: 'rotate(deg)',
              }}
              alt="borboleta0"
              src={borboleta1}
            />
            <img
              style={{
                position: 'absolute',
                top: 2100,
                left: 125,
                height: 95,
                width: 95,
                // transform: 'rotate(deg)',
              }}
              alt="borboleta2"
              src={borboleta2}
            />
            <img
              style={{
                position: 'absolute',
                top: 780,
                right: 90,
                zIndex: 1,
                height: 80,
                width: 80,
                transform: 'rotate(12deg)',
              }}
              src={borboleta4}
              alt="borboleta4"
            />
            <div className="services-container">
              <ServiceCard
                title="Consulta Pediátrica Pré-Natal"
                description={`<p>O primeiro contato entre a família e o Pediatra deve acontecer, idealmente, antes do nascimento da criança, por volta da 30ª semana de gestação. Essa consulta é essencial para:</p>
                <ul>
                  <li>Conhecer e escolher o profissional que irá acompanhar a família após o nascimento da criança</li>
                  <li>Avaliar a evolução da gestação e exames realizados até o momento, checando e intervindo em eventuais fatores de risco para saúde da criança</li>
                  <li>Checar e adequar imunizações da gestante</li>
                  <li>Tirar dúvidas e planejar cuidados com o bebê durante o parto e primeiras horas de vida</li>
                </ul>`}
                image={services1}
                BackgroundStyle="darkGreenBG"
              />
              <ServiceCard
                title="Acompanhamento do Primeiro Mês de Vida"
                description={`<p>O primeiro mês de vida requer cuidados específicos tanto do ponto de vista clínico, quanto em relação à adaptação da casa à chegada do bebê.</p>
                  <p>A primeira consulta do bebê após a alta da maternidade deve acontecer idealmente no quinto dia de vida, momento ideal para avaliar a presença de icterícia neonatal, estabelecimento do aleitamento materno e ganho de peso.</p>
                  <p>Partindo das condições clínicas do bebê e necessidades familiares, estabelecemos um planejamento em relação à periodicidade de consultas no primeiro mês.</p>
                  <p>Quando necessário, o acompanhamento do primeiro mês de vida pode ser realizado em domicílio.</p>`}
                // image={services1}
                width="40%"
                BackgroundStyle="grayBG"
              />
            </div>

            <div className="services-container">
              <ServiceCard
                  title={`Consulta de Puericultura
                        "Consulta de Rotina"`}
                description={`<p>As consultas de Puericultura acontecem mensalmente, pelo menos até o sexto mês de vida. A partir de então os intervalos são definidos de maneira individualizada, à depender do contexto da criança e sua familia.</p>
                  <p>Nestes encontros avaliamos: peso, crescimento, desenvolvimento infantil, vacinação, rotinas (alimentação, sono, atividade física, uso de telas), além, claro de todas as outras demandas trazidas pela família.</p>`}
                // image={services1}
                width="55%"
                BackgroundStyle="grayBG"
              />
              <ServiceCard
                  title="Consulta Pediátrica de Urgência "
                description={`<p></p>
                    <p>A agenda em meu consultório é organizada de forma a viabilizar o atendimento de quadros agudos e urgentes com maior agilidade. Garantindo que a criança seja avaliada pelo profissional que já a conhece, e reduzindo a necessidade de visitas a pronto-atendimentos.</p>`}
                image={services2}
                BackgroundStyle="lightGreenBG"
                ImageHeight={350}
                InvertedImage={false}
              />
            </div>
            <Spacer size={50} />
          </FixWidthContainer>
        </>
      )}
    </div>
  )
}

export default Services
